import {
  faCircleInfo,
  faCloudArrowUp,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  FormHelperText,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { InputLabel } from "@mui/material";
import labels from "../../../dictionaries/labels.json";
import { removeNthEl, saveFile } from "../../../lib/helperFuncs";

function SimpleFileUpload(props) {
  const { name, formik, disabled, ...rest } = props;
  const [files, setFiles] = useState(formik.values[name] || []);
  const [fileIsString, setFileIsString] = useState(false);

  useEffect(() => {
    if (typeof formik.values[name] === "string") {
      setFileIsString(true);
    }
  }, [formik]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          borderStyle: "dashed",
          borderColor: "#046ec5",
          borderWidth: "1px",
          justifyContent: "center",
          gap: 5,
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <Box m={5} display="flex" flexDirection="column" gap={5}>
          <FontAwesomeIcon size="5x" color="#046ec5" icon={faCloudArrowUp} />
          <Button
            sx={{ whiteSpace: "nowrap", textAlign: "center" }}
            color={"secondary"}
            variant="outlined"
            component="label"
            disabled={disabled}
          >
            {labels.Labels.FileUpload}
            <input
              multiple
              {...rest}
              onChange={(e) => {
                const newState = [...files, ...e.target.files];
                setFiles(newState);
                formik.setFieldValue(`${name}`, newState);
              }}
              type="file"
              hidden
            />
          </Button>
        </Box>
        <Box display="flex" flexDirection="column" gap={2}>
          {files.map((x, index) => {
            return (
              <>
                <Box
                  display="flex"
                  gap={5}
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Tooltip title={labels.tooltip.checkSelectedFile}>
                    {fileIsString ? (
                      <Button
                        variant="text"
                        onClick={(e) =>
                          saveFile(formik.values[name], e.target.textContent)
                        }
                      >
                        {x.name}
                      </Button>
                    ) : (
                      <Button variant="text" onClick={() => {}}>
                        {typeof x === "string" ? x?.split("/")?.at(-1) : x.name}
                      </Button>
                    )}
                  </Tooltip>

                  <Tooltip
                    sx={{ height: "fit-content" }}
                    title={labels.tooltip.deleteEntry}
                    arrow
                  >
                    <IconButton
                      onClick={() => {
                        const newState = removeNthEl(files, index);
                        formik.setFieldValue(`${name}`, newState);
                        setFiles(newState);
                      }}
                      size="small"
                    >
                      <FontAwesomeIcon icon={faXmarkCircle} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </>
            );
          })}
        </Box>
      </Box>
    </>
  );
}

// wrapped in textFiled
function _FormFileUpload(props) {
  const {
    label,
    required,
    propertyDescription1,
    propertyDescription2,
    template,
  } = props;
  return (
    <>
      <InputLabel
        sx={{
          textAlign: "left",
          textStyle: "none",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: required ? "bold" : "500",
          }}
        >
          {label}
          {template?.length > 0 && (
            <Tooltip
              title="Έχει προστεθεί template για αυτόν τον τύπο αρχείου"
              placement="right-start"
            >
              <span>
                <FontAwesomeIcon
                  color="#046ec5"
                  size="xs"
                  icon={faCircleInfo}
                  style={{ marginLeft: "10px", verticalAlign: "middle" }}
                />
              </span>
            </Tooltip>
          )}
        </Typography>
        <Typography variant="subtitle1" color="light.main">
          {propertyDescription1} <br></br>
          {propertyDescription2}
        </Typography>
      </InputLabel>
      <Box>
        <SimpleFileUpload {...props} />
      </Box>
    </>
  );
}

function FormFileUpload(props) {
  const { name, formik } = props;
  return (
    <>
      <Grid>
        <Box
          sx={{
            borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
            paddingLeft: formik.errors[name] ? "16px" : "",
          }}
        >
          <_FormFileUpload {...props} />
          {!!formik.errors[name] && (
            <FormHelperText error>
              <Typography
                variant="body1"
                sx={{
                  marginTop: "16px",
                  fontWeight: "bolder",
                }}
              >
                {formik.errors[name]}
              </Typography>
            </FormHelperText>
          )}
        </Box>
      </Grid>
    </>
  );
}

export default FormFileUpload;
